export default {
    _prefix: "agentScoringRules.common",
    labels: {
        title: "Agent Scoring Rules",
        accessRestricted:
            "Access Restricted: You don't have the required permissions to access this tab",
        restrictedByPermissions: "Restricted by permissions",
        agentsToScore: {
            label: "Agents to Score",
            each: "Each Matched Agent",
            first: "First Matched Agent Only",
            last: "Last Matched Agent Only",
        },
    },
};
